import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { GetMentoringDetailsRes } from '../models';

export interface MentoringPreviewApi {
  getMentoringDetails(
    templateId: number,
  ): Observable<GetMentoringDetailsRes>;
}

export const MENTORING_PREVIEW_API = new InjectionToken<MentoringPreviewApi>(
  'MENTORING_PREVIEW_API',
);
